export const SET_SOOTHE_PASS_SUBSCRIPTIONS = 'SET_SOOTHE_PASS_SUBSCRIPTIONS';

export function setSoothePassSubscriptions(soothePassSubscriptions) {
  return {
    type: SET_SOOTHE_PASS_SUBSCRIPTIONS,
    payload: soothePassSubscriptions,
  };
}
